import type { DocumentIndicatorsPayload } from '@Application/Indicators/Actions/documentIndicatorsFetched';
import DocumentTypeCountView from '@UI/Store/Indicators/Views/DocumentTypeCountView';
import IndicatorComparisonView from '@UI/Store/Indicators/Views/IndicatorComparisonView';
import IndicatorPeriodView from '@UI/Store/Indicators/Views/IndicatorPeriodView';

/** Immutable View: `readonly` properties, frozen at the end of the constructor. */
class DocumentIndicatorsView {
	readonly queryKey: string;
	readonly period: IndicatorPeriodView;
	readonly generated: IndicatorComparisonView;
	readonly byType: readonly DocumentTypeCountView[];

	constructor(payload: DocumentIndicatorsPayload) {
		this.queryKey = payload.queryKey;
		this.period = new IndicatorPeriodView(payload.period);
		this.generated = new IndicatorComparisonView(payload.generated);
		this.byType = payload.byType.map((entry) => new DocumentTypeCountView(entry));

		Object.freeze(this);
	}
}

export default DocumentIndicatorsView;
